import React from 'react'
import {Link} from 'react-router-dom'

const Order = () => {
  
  return (
    <div>
      <div>
        <Link to='/orders/kitchen'>Kitchen Display</Link>
      </div>
    </div>
  )
}

export default Order